import { render, staticRenderFns } from "./ticketInfo.vue?vue&type=template&id=3c2ba0f0&scoped=true&"
import script from "./ticketInfo.vue?vue&type=script&lang=js&"
export * from "./ticketInfo.vue?vue&type=script&lang=js&"
import style0 from "./ticketInfo.vue?vue&type=style&index=0&id=3c2ba0f0&lang=less&scoped=true&"
import style1 from "./ticketInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ba0f0",
  null
  
)

export default component.exports